export class ArrayUtils {
    public static arrayDiffBy(array1, array2, propertyName): Array<Object> {
      if ( !(array1 instanceof Array && array2 instanceof Array)) {
          return [];
      }
      let diffs = [];
      for(let i = 0; i < array1.length; ++i){
          let found = false;
          let propertyValue = array1[i][propertyName];
          for (let j = 0; j < array2.length; ++j) {
              if (array2[j][propertyName] === propertyValue){
                  found = true;
                  break;
              }
          }
          if (!found) {
              diffs.push(array1[i]);
          }
      }
      return diffs;
    }

    public static doesArrayContainsValue(array, propertyName, propertyValue): boolean {
      for(let  i = 0; i < array.length; ++i){
          if(array[i][propertyName] === propertyValue){
              return true;
          }
      }
      return false;
    }

    public static isPropertyExist(sourceObject, propertyString): boolean {
        // propertyString: property1.property2.property3
        if (!sourceObject || !propertyString) {
            return false;
        }
        let properties = propertyString.split('.');
        if (properties.length === 0) {
            return false;
        }
        for(var index in properties) {
            if(typeof sourceObject[properties[index]] === 'undefined') {
                return false;
            }
            sourceObject = sourceObject[properties[index]];
        }
            return true;
    }
}



// WEBPACK FOOTER //
// ./src/common/utils/array-utils.ts